module.exports = __webpack_public_path__ + "img/ico03.1199b3cf.svg";